<template>
  <v-container :class="small ? 'text-right pa-0' : 'text-right pa-0 pt-3'">
    <template v-if="small">
      <small>Total Price:</small>
      <b>{{ totalSell | priceLabeler }}</b
      ><small>{{ currency }}</small
      ><span v-html="discountInfo"></span>
    </template>
    <h6 v-else class="headline green--text font-weight-light">
      <v-progress-circular
        v-if="this.$apollo.loading"
        indeterminate
        color="green"
        :width="2"
        :size="25"
      ></v-progress-circular>
      <small>Total Price:</small>
      <b>{{ totalSell | priceLabeler }}</b
      ><small>{{ currency }}</small
      ><span v-html="discountInfo"></span>
    </h6>
    <v-alert :value="error" type="error">{{ errorMsg }}</v-alert>
    <div v-if="debug">
      <p>start date: {{ formattedStartDate }}</p>
      <p>end date: {{ endDate }}</p>
      <p>agentId: {{ agentId }}</p>
      <p>serviceId: {{ serviceId }}</p>
      <p>adults: {{ adults }}</p>
      <p>children: {{ children }}</p>
      <p>infants: {{ infants }}</p>
      <p>qty: {{ qty }}</p>
      <p>{{ startDate }} - {{ endDate }}</p>
      <p>extras: {{ extras }}</p>
      <p>{{ itemPricing }}</p>
    </div>
  </v-container>
</template>

<script>
import { GET_PRICE_BREAKDOWN_QUERY } from "../../../../../constants/graphql";
import moment from "moment";
export default {
  name: "ItemTotalPriceInfo",
  props: {
    serviceId: {
      type: String,
      default: () => "",
    },
    agentId: {
      type: String,
      default: () => null,
    },
    adults: {
      type: String,
      default: () => "2",
    },
    children: {
      type: String,
      default: () => "0",
    },
    infants: {
      type: String,
      default: () => "0",
    },
    qty: {
      type: String,
      default: () => "1",
    },
    createdAt: {
      type: String,
      default: () => null,
    },
    startDate: {
      type: String,
      default: () => new Date().toUTCString(),
    },
    endDate: {
      type: String,
      default: () => new Date().toUTCString(),
    },
    getPrice: {
      type: Boolean,
      default: () => false,
    },
    extras: {
      type: Array,
      default: () => [],
    },
    department: {
      type: String,
      default: () => "",
    },
    ratePlan: {
      type: String,
      default: () => null,
    },
    skip: {
      type: Boolean,
      default: () => true,
    },
    adjustment: {
      type: Number,
      default: () => 0,
    },
    small: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: "No errors",
      itemPricing: { totalSell: 0, currencySell: "" },
    };
  },

  watch: {
    getPrice(val) {
      //console.log("loading price");
    },
  },

  computed: {
    formattedStartDate() {
      return new moment(this.startDate).format("YYYY-MM-DDTHH:mm:ss");
    },
    formattedEndDate() {
      return new moment(this.endDate).format("YYYY-MM-DDTHH:mm:ss");
    },
    extrasDiscount() {
      return this.itemPricing && this.itemPricing.extras
        ? this.itemPricing.extras.reduce((d, e) => (d += Number(e.discount)), 0)
        : 0;
    },
    currency() {
      return this.itemPricing ? this.itemPricing.currencySell : "";
    },
    totalSell() {
      return this.itemPricing
        ? this.itemPricing.totalSell + this.adjustment
        : "";
    },
    discountInfo() {
      return (this.itemPricing &&
        this.itemPricing.discount &&
        this.itemPricing.discount > 0) ||
        this.extrasDiscount > 0
        ? `<small> - Included Discount:</small> <b>${
            this.itemPricing.discount + this.extrasDiscount
          }</b><small>${this.itemPricing.currencySell}</small>`
        : "";
    },
  },

  methods: {
    handleMessage() {
      if (this.itemPricing && this.itemPricing.message) {
        this.errorMsg = this.itemPricing.message;
        this.error = true;
      } else {
        this.error = false;
        this.errorMsg = "No errors";
      }
    },
  },

  apollo: {
    itemPricing: {
      query: GET_PRICE_BREAKDOWN_QUERY,
      variables() {
        //console.log("fetching price breakdown", this.createdAt);
        return {
          serviceId: this.serviceId,
          agentId: this.agentId,
          department: this.department != "" ? this.department : undefined,
          ratePlan: this.ratePlan ? this.ratePlan : "",
          itineraryCreationDate: this.createdAt,
          startDate: this.formattedStartDate,
          endDate: this.formattedEndDate,
          adults: Number(this.adults),
          children: Number(this.children),
          infants: Number(this.infants),
          qty: Number(this.qty),
          extras: this.extras.map((e) => {
            let extraQty = e.qty;
            if (e.rateBase == "P") {
              if (e.isChildOnly && e.children) {
                extraQty = Number(e.children);
              } else if (e.isInfantOnly && e.infants) {
                extraQty = Number(e.infants);
              } else if (e.adults) {
                extraQty = Number(e.adults);
              }
            }
            return {
              id: e.id,
              qty: extraQty,
              startDate: e.startDate,
              endDate: e.endDate,
            };
          }),
        };
      },
      skip() {
        return !this.getPrice || this.serviceId == "" || this.skip;
      },
      fetchPolicy: "network-only",
      result(result) {
        if (!result.error) {
          //console.log("loaded breakdown: ", result.data);
          const { message, ...itemPricing } = result.data.itemPricing;
          this.$emit("onLoad", itemPricing);
          this.handleMessage();
        }
      },
      error(error) {
        this.$emit("onLoadError", error.message);
        this.error = true;
        this.errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItemTotalPriceInfo.vue